import Cookies from 'js-cookie';

export const GDPR_GA = 'settings-gdpr-GA-accept';
export const GDPR_TGM = 'settings-gdpr-GTM-accept';
export const GDPR_FB = 'settings-gdpr-FB-accept';

export const isGdprOpen = () =>
  !(Cookies.get(GDPR_GA) && Cookies.get(GDPR_TGM) && Cookies.get(GDPR_FB));
